import { render, staticRenderFns } from "./MiroCard.vue?vue&type=template&id=86f34cd2&scoped=true&"
import script from "./MiroCard.vue?vue&type=script&lang=js&"
export * from "./MiroCard.vue?vue&type=script&lang=js&"
import style0 from "./MiroCard.vue?vue&type=style&index=0&id=86f34cd2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f34cd2",
  null
  
)

export default component.exports